import { useState } from "react"
import { PWA_ENABLED } from '../Pwa';

export const InstallState = () => {
    const [install, setInstall] = useState(null)
    const [ip, setIp] = useState({stat: false, prompt_type: null})

    return {
        prompt: {data: PWA_ENABLED ? install : null, set: (value) => { if (PWA_ENABLED) setInstall(value); }},
        ip: {data: PWA_ENABLED ? ip : {stat: false, prompt_type: null}, set: (value) => { if (PWA_ENABLED) setIp(value); }}
    }
}
